import { render, staticRenderFns } from "./OperaCustomerWindow.vue?vue&type=template&id=282c9d1c&"
import script from "./OperaCustomerWindow.vue?vue&type=script&lang=js&"
export * from "./OperaCustomerWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports